import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/rc-time-constant-calculator',
  component: () => import('../../routes/RcTimeConstantCalculator.svelte'),
  card: {
    id: 'rc-time-constant',
    title: 'RC Time Constant Calculator',
    description:
      'Compute the RC time constant (τ = R × C), evaluate capacitor voltage on charging/discharging curves, and find the time to reach a target percentage. Includes 11 capacitor presets.',
    icon: 'bolt',
    iconBgClass: 'bg-cyan-50',
    iconTextClass: 'text-cyan-600',
    href: '/rc-time-constant-calculator',
    category: 'Physics & Science',
  },
  seo: {
    title: 'RC Time Constant Calculator – τ = R × C, V(t), Time-to-%',
    description:
      'Free RC time constant calculator. Computes τ from resistance and capacitance, evaluates V(t) on charging and discharging exponential curves, and solves for the time at which a capacitor reaches a target percentage of its final value. Includes 11 capacitor presets from 10 pF to 1 F.',
  },
};

export default meta;
